export default {
    "not-auth": "Siz noto'g'ri raqam yoki parol kiritdingiz",
    "100": "Bu raqam bilan faol foydalanuvchi allaqachon mavjud",
    "101": "Bu telefon raqami allaqachon ro'yxatdan o'tgan va faollashtirish kutmoqda",
    "102": "Telefon raqamingizni tasdiqlang",
    "103": "Ro'yxatdan o'tish muvaffaqiyatsiz tugadi",
    "104": "Raqamni faollashtirish muvaffaqiyatli o'tdi",
    "105": "Bu raqamga ega foydalanuvchi allaqachon faollashtirilgan",
    "106": "Tasdiq kodi noto'g'ri",
    "107": "Telefon raqami noto'g'ri",
    "108": "Tasdiqlash kodi yuborildi",
    "109": "Bu raqamga ega foydalanuvchi allaqachon faollashtirilgan",
    "110": "Telefon raqami noto'g'ri",
    "111": "Tasdiqlash kodi yuborildi",
    "112": "Telefon raqami noto'g'ri",
    "113": "Kodni tasdiqlash muvaffaqiyatli amalga oshirildi",
    "114": "Tasdiq kodi noto'g'ri",
    "115": "Hisob muvaffaqiyatli tiklandi",
    "116": "Tasdiq kodi noto'g'ri",
    "117": "Parolni tekshirish muvaffaqiyatli o'tdi",
    "118": "Noto'g'ri parol kiritildi",
    "119": "Parol muvaffaqiyatli o'zgartirildi",
    "120": "Parol mos kelmadi",
    "121": "Promo-kod topilmadi",
    "122": "Promo-kod allaqachon faollashtirilgan",
    "123": "Promo-kod faollashtirilgan",
    "202": "Profilingiz muvaffaqiyatli yangilandi",
    "203": "Profilingizni yangilab bo'lmadi",
    "209": "Nimadir noto'g'ri bajarildi ",
    "402": "Bu kurs savatga qo'shildi",
    "406": "Bu kurs savatdan olib tashlandi",
    "409": "Bu kurs sizni qiziqtirgan kurslar ro'yxatidan olib tashlandi",
    "410": "Bu kurs sizni qiziqtirgan kurslar ro'yxatiga qo'shildi",
    "330": "To'g'ri karta ma'lumotlarini kiriting",
    "310": "Faollashtirish muvaffaqiyatli o'tdi",
    "531": "Bu darslik mavjud emas",
    "511": "Kurs topilmadi",
    "556": "Sertifikat topilmadi",
    "754": "Nimadir noto'g'ri bajarildi",
    "352": "Balansingizda mablag yetarli emas",
    "350": "Tez orada pul mablag'larini amalga oshiriladi",
    "757": "To'lov muvaffaqiyatli bo'ldi",
    "762": "To'lov uchun mablag' etarli emas",
    "copy": "Havola vaqtinchalik xotirangizga muvaffaqiyatli ko'chirildi",
    "quiz-blocked": "Sinov hozirda siz uchun bloklangan",
    "notAnswer": "Iltimos, tekshirishdan oldin savolga javob bering",
    "no-auth": "Iltimos, oldiniga ro`yxatdan o`ting",
    "950": "Muvaffaqiyatli jo'natildi",
    "902": "Ko'p sonli noto'g'ri javoblar. Urinishlar soni 1 ga kamaydi",
    "903": "Sinov 1 kunga bloklanadi, chunki boshqa urinishlaringiz yoʻq",
    "904": "Sinov muvaffaqiyatli o'tdi. Sertifikat sizning hisobingizda paydo bo'ladi"
}